import {
    ActiveIntegrations, IntegrationInfo, IntegrationParameters,
    IntegrationSettings,
    IntegrationStatus,
    ObjectsProperty
} from 'src/pages/integrations/data/types';
import { createController, createControllerEndpoint } from 'src/utils/api';
import { getGlobalProject } from 'src/utils/globals';
import {ApiKey} from "src/pages/integrations/data/types/ApiKey";
import { SurveyIntegrations } from 'src/data/types/surveys/types';

const project = getGlobalProject() || { UniqueCode: '' };

export default createController('/api/v2/integrations/' + project.UniqueCode, {
    getActiveIntegrations: createControllerEndpoint<ActiveIntegrations>('GET', '/client-side/active'),
    activateIntegration: createControllerEndpoint<ActiveIntegrations>('PUT', '/client-side/state'),
    deactivateIntegration: createControllerEndpoint<ActiveIntegrations>('DELETE', '/client-side/state'),
    activateServerSideIntegration: createControllerEndpoint<ActiveIntegrations>('PUT', '/server-side/state'),
    deactivateServerSideIntegration: createControllerEndpoint<ActiveIntegrations>('DELETE', '/server-side/state'),
    getSettings: createControllerEndpoint<IntegrationSettings>('GET', '/{integrationType}/settings'),
    setSettings: createControllerEndpoint<IntegrationSettings>('PUT', '/{integrationType}/settings'),
    getObjectsPropertiesRefreshed: createControllerEndpoint<ObjectsProperty[]>('GET', '/{integrationType}/{objectType}/properties?refresh=true'),
    saveObjectsPropertiesMappings: createControllerEndpoint<ObjectsProperty[]>('POST', '/{integrationType}/{objectType}/properties/mappings'),
    runFullSync: createControllerEndpoint<IntegrationStatus>('POST', '/{integrationType}/sync'),
    getInfo: createControllerEndpoint<IntegrationInfo>('GET', '/{integrationType}/info'),
    getParameters: createControllerEndpoint<IntegrationParameters>('GET', '/{integrationType}/parameters'),
    getApiKeys: createControllerEndpoint<ApiKey[]>('GET', '/api-keys'),
    generateApiKey: createControllerEndpoint<ApiKey>('POST', '/api-keys/generate'),
    updateApiKey: createControllerEndpoint<ApiKey>('PUT', '/api-keys/{id}'),
    deleteApiKey: createControllerEndpoint<null>('DELETE', '/api-keys/{id}'),

    getSurveyIntegrations: createControllerEndpoint<SurveyIntegrations>('GET', '/settings/all/survey-answers/{surveyId}'),
    setSurveyIntegrations: createControllerEndpoint<SurveyIntegrations>('PUT', '/settings/all/survey-answers/{surveyId}'),
});
